import React, { useEffect, useRef, useState } from "react";
import { Formik, Form, Field } from "formik";
import { Container, Row, Col, Card } from "react-bootstrap";
import { TextField } from "../reusable/TextField";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSeedling,
  faClipboardList,
  faFlask,
  faCommentDots,
  faEye,
  faCalendarCheck,
  faCamera,
  faSpinner,
} from "@fortawesome/free-solid-svg-icons";
import validationSchema from "./validationSchema";
import ModalAlert from "../reusable/ModalAlert";
import { styles } from "./styles";
import moment from "moment";
import getAllUsers from "./getAllUsers";
import getLabels from "./getlabels";
import getProducts from "./getProducts";
import getCrops from "./getAllCrops";
import colors from "../../config/colors";
import editIssueDetails from "./editIssue";
import Select from "react-select";
import LoadingSpinner from "../reusable/LoadingSpinner";
import uploadIssuePhoto from "../Crop/uploadIssuePhoto";
import SolutionsEditor, { emptySolution } from "../reusable/SolutionsEditor";
import ImageCropModal from "../reusable/ImageCropModal";

const CROP_STAGES = [
  "Seedling",
  "Vegetative",
  "Tillering",
  "Flowering",
  "Fruiting",
  "Maturity",
  "Harvesting",
];
const SEASONS = ["Kharif", "Rabi", "Zaid", "All Season"];
const APP_METHODS = [
  "Spraying",
  "Drip Irrigation",
  "Soil Application",
  "Seed Treatment",
  "Foliar Spray",
  "Fertigation",
];

const SH = ({ icon, title }) => (
  <div
    style={{
      display: "flex",
      alignItems: "center",
      gap: 10,
      marginBottom: "1rem",
      marginTop: "1.25rem",
      paddingTop: "1rem",
      borderTop: "1.5px solid #e8f0eb",
    }}
  >
    <div
      style={{
        width: 26,
        height: 26,
        borderRadius: 7,
        backgroundColor: "#1a3328",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <FontAwesomeIcon
        icon={icon}
        style={{ color: "#fff", fontSize: "0.72rem" }}
      />
    </div>
    <span style={{ fontWeight: 700, fontSize: "0.9rem", color: "#1a3328" }}>
      {title}
    </span>
  </div>
);

const IssueDetails = (props) => {
  const [isEdit, setIsEdit] = useState(false);
  const [issueDetails, setIssueDetails] = useState(props?.issueDetails);
  const [loadingInfo, setLoadingInfo] = useState(false);
  const [allUsers, setAllUsers] = useState([]);
  const [allLabels, setAllLabels] = useState([]);
  const [allProducts, setAllProducts] = useState([]);
  const [allCrops, setAllCrops] = useState([]);
  const [fetching, setFetching] = useState(false);
  const [showEditIssueAlert, setShowEditIssueAlert] = useState(false);
  const [showImgSizeErr, setShowImgSizeErr] = useState(false);
  const [lightboxUrl, setLightboxUrl] = useState(null);
  const [cropTarget, setCropTarget] = useState({ field: null, file: null });

  const loadAllUsers = async () => {
    const allUsersResponse = await getAllUsers();
    if (allUsersResponse.status == 200) {
      setAllUsers(allUsersResponse.data);
    } else {
      console.log(allUsersResponse);
    }
  };

  const loadLabels = async () => {
    const allLabelsResponse = await getLabels();
    if (allLabelsResponse.status == 200) {
      setAllLabels(allLabelsResponse.data);
    } else {
      console.log(allLabelsResponse);
    }
  };

  const loadProducts = async () => {
    const allProductsResponse = await getProducts();
    if (allProductsResponse.status == 200) {
      setAllProducts(allProductsResponse.data);
    } else {
      console.log(allProductsResponse);
    }
  };

  const loadCrops = async () => {
    const allCropsResponse = await getCrops();
    if (allCropsResponse.status == 200) {
      setAllCrops(allCropsResponse.data);
    } else {
      console.log(allCropsResponse);
    }
  };

  const loadIds = () => {
    if (issueDetails) {
      if (issueDetails.reporter)
        issueDetails.reporter = issueDetails.reporter._id;
      if (issueDetails.assignee)
        issueDetails.assignee = issueDetails.assignee._id;
      if (issueDetails.cropID) {
        issueDetails.cropID = issueDetails.cropID._id;
        if (issueDetails.categoryID) {
          issueDetails.categoryID = issueDetails.categoryID._id;
          if (issueDetails.problemID)
            issueDetails.problemID = issueDetails.problemID._id;
        }
      }
    }
  };

  useEffect(() => {
    setIssueDetails(props?.issueDetails);
  }, [props?.issueDetails]);

  useEffect(() => {
    setFetching(true);
    loadAllUsers();
    loadLabels();
    loadProducts();
    loadCrops();
    loadIds();
    setFetching(false);
  }, []);

  const handleEditIssue = async (values) => {
    console.log("In handle edit issue");
    if (
      values.issueCode &&
      values.issueType &&
      values.status &&
      values.reporter &&
      values.assignee
    ) {
      if (values.issueType == "Other" || values.issueType == "Soil Related") {
        values.cropID = null;
        values.categoryID = null;
        values.problemID = null;
      } else {
        if (values.cropID == null) {
          values.categoryID = null;
          values.problemID = null;
        } else if (values.categoryID == null) {
          values.problemID = null;
        }
      }
      const editIssueResponse = await editIssueDetails(values);
      if (editIssueResponse.status == 200) {
        setIsEdit(false);
        props.reloadData();
      } else {
        console.log(editIssueResponse);
        setShowEditIssueAlert(true);
      }
    } else {
      console.log("Error");
      setShowEditIssueAlert(true);
    }
  };

  const handleCancel = (resetForm) => {
    setIsEdit(false);
    resetForm();
  };

  return (
    <>
      {!issueDetails && fetching ? (
        <LoadingSpinner />
      ) : (
        <Formik
          enableReinitialize={true}
          initialValues={issueDetails}
          validationSchema={validationSchema}
          onSubmit={(values) => {
            console.log(values);
            console.log("HIiii");
            handleEditIssue(values);
          }}
        >
          {(formikProps) => {
            const {
              handleSubmit,
              resetForm,
              handleChange,
              handleBlur,
              values,
              touched,
              errors,
              setFieldValue,
              isValid,
            } = formikProps;
            return (
              <>
                <Card style={styles.card}>
                  <Card.Header style={styles.displayCardHeader}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: "1rem",
                      }}
                    >
                      <div>
                        <span
                          style={{
                            fontWeight: 700,
                            fontSize: "0.85rem",
                            letterSpacing: "0.06em",
                            textTransform: "uppercase",
                            color: "#fff",
                          }}
                        >
                          Query Details
                        </span>
                        <div
                          style={{
                            display: "flex",
                            gap: "1.5rem",
                            marginTop: 3,
                          }}
                        >
                          <span
                            style={{
                              fontSize: "0.72rem",
                              color: "rgba(255,255,255,0.65)",
                            }}
                          >
                            Date Raised:{" "}
                            <strong style={{ color: "#fff", fontWeight: 600 }}>
                              {values.created_at
                                ? moment(values.created_at).format(
                                    "DD-MMM-YYYY",
                                  )
                                : "—"}
                            </strong>
                          </span>
                          <span
                            style={{
                              fontSize: "0.72rem",
                              color: "rgba(255,255,255,0.65)",
                            }}
                          >
                            Updated:{" "}
                            <strong style={{ color: "#fff", fontWeight: 600 }}>
                              {values.updated_at
                                ? moment(values.updated_at).format(
                                    "DD-MMM-YYYY",
                                  )
                                : "—"}
                            </strong>
                          </span>
                        </div>
                      </div>
                      <div style={{ flexShrink: 0 }}>
                        {!isEdit ? (
                          <button
                            type="button"
                            onClick={() => setIsEdit(true)}
                            style={{
                              backgroundColor: "rgba(255,255,255,0.15)",
                              color: "#fff",
                              border: "1.5px solid rgba(255,255,255,0.35)",
                              borderRadius: 7,
                              padding: "0.35rem 1rem",
                              fontSize: "0.82rem",
                              fontWeight: 600,
                              cursor: "pointer",
                            }}
                          >
                            ✏️ Edit
                          </button>
                        ) : (
                          <div style={{ display: "flex", gap: 8 }}>
                            <button
                              type="button"
                              onClick={() => handleSubmit()}
                              style={{
                                backgroundColor: "#3d8c5e",
                                color: "#fff",
                                border: "none",
                                borderRadius: 7,
                                padding: "0.35rem 1.1rem",
                                fontSize: "0.82rem",
                                fontWeight: 600,
                                cursor: "pointer",
                              }}
                            >
                              ✓ Save
                            </button>
                            <button
                              type="button"
                              onClick={() => handleCancel(resetForm)}
                              style={{
                                backgroundColor: "#fdecea",
                                color: "#c62828",
                                border: "1.5px solid #c62828",
                                borderRadius: 7,
                                padding: "0.35rem 1rem",
                                fontSize: "0.82rem",
                                fontWeight: 600,
                                cursor: "pointer",
                              }}
                            >
                              ✕ Cancel
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  </Card.Header>
                  <Card.Body>
                    <Form>
                      {/* ── Section 1: Crop Basic Details ── */}
                      <SH icon={faSeedling} title="Crop Basic Details" />
                      <Row>
                        <Col md={4}>
                          <label style={styles.label}>Crop</label>
                          <Field
                            style={
                              isEdit ? styles.select : styles.selectDisabled
                            }
                            as="select"
                            name="cropID"
                            disabled={!isEdit}
                            onChange={(e) => {
                              setFieldValue("cropID", e.target.value);
                              setFieldValue("categoryID", null);
                              setFieldValue("problemID", null);
                            }}
                          >
                            <option value="">Select Crop</option>
                            {allCrops.map((val) => (
                              <option key={val._id} value={val._id}>
                                {val.crop}
                              </option>
                            ))}
                          </Field>
                        </Col>
                        <Col md={4}>
                          <label style={styles.label}>Crop Stage</label>
                          <Field
                            style={
                              isEdit ? styles.select : styles.selectDisabled
                            }
                            as="select"
                            name="cropStage"
                            disabled={!isEdit}
                          >
                            <option value="">Select Stage</option>
                            {CROP_STAGES.map((s) => (
                              <option key={s} value={s}>
                                {s}
                              </option>
                            ))}
                          </Field>
                        </Col>
                        <Col md={4}>
                          <label style={styles.label}>Season</label>
                          <Field
                            style={
                              isEdit ? styles.select : styles.selectDisabled
                            }
                            as="select"
                            name="season"
                            disabled={!isEdit}
                          >
                            <option value="">Select Season</option>
                            {SEASONS.map((s) => (
                              <option key={s} value={s}>
                                {s}
                              </option>
                            ))}
                          </Field>
                        </Col>
                      </Row>
                      <Row className="mt-2">
                        <Col md={4}>
                          <TextField
                            label="Variety"
                            name="variety"
                            type="text"
                            disabled={!isEdit}
                          />
                        </Col>
                        <Col md={4}>
                          <label style={styles.label}>Sowing Date</label>
                          <Field
                            style={
                              isEdit ? styles.select : styles.selectDisabled
                            }
                            type="date"
                            name="sowingDate"
                            disabled={!isEdit}
                          />
                        </Col>
                        <Col md={4}>
                          <TextField
                            label="Area Under Crop (Acre/Hectare)"
                            name="areaUnderCrop"
                            type="text"
                            disabled={!isEdit}
                          />
                        </Col>
                      </Row>

                      {/* ── Section 2: Problem Description ── */}
                      <SH
                        icon={faClipboardList}
                        title="Problem Description & History"
                      />
                      <Row>
                        <Col md={6}>
                          <label style={styles.label}>Last Dose Taken</label>
                          <Field
                            style={{
                              ...(isEdit
                                ? styles.textarea
                                : styles.textareaDisabled),
                              height: "6rem",
                            }}
                            name="lastDoseTaken"
                            as="textarea"
                            disabled={!isEdit}
                          />
                        </Col>
                        <Col md={6}>
                          <label style={styles.label}>Symptoms</label>
                          <Field
                            style={{
                              ...(isEdit
                                ? styles.textarea
                                : styles.textareaDisabled),
                              height: "6rem",
                            }}
                            name="symptomsText"
                            as="textarea"
                            disabled={!isEdit}
                          />
                        </Col>
                      </Row>
                      <Row className="mt-2">
                        <Col md={6}>
                          <label style={styles.label}>Query Type</label>
                          <Field
                            style={
                              isEdit ? styles.select : styles.selectDisabled
                            }
                            as="select"
                            name="issueType"
                            disabled={!isEdit}
                          >
                            <option value="Crop Related">Crop Related</option>
                            <option value="Soil Related">Soil Related</option>
                            <option value="Fertilizer Management">
                              Fertilizer Management
                            </option>
                            <option value="Other">Other</option>
                          </Field>
                        </Col>
                        <Col md={6}>
                          <label style={styles.label}>Query Category</label>
                          <Field
                            style={
                              isEdit ? styles.select : styles.selectDisabled
                            }
                            as="select"
                            name="categoryID"
                            disabled={!isEdit || !values.cropID}
                          >
                            <option value="">Select Query Category</option>
                            {values.cropID &&
                              allCrops
                                .filter((c) => c._id == values.cropID)[0]
                                ?.categories.map((cat) => (
                                  <option key={cat._id} value={cat._id}>
                                    {cat.category}
                                  </option>
                                ))}
                          </Field>
                        </Col>
                      </Row>
                      <Row className="mt-2">
                        <Col md={6}>
                          <label style={styles.label}>
                            Crop Query (Online)
                          </label>
                          <Field
                            style={{
                              ...(isEdit
                                ? styles.textarea
                                : styles.textareaDisabled),
                              height: "6rem",
                            }}
                            name="title"
                            as="textarea"
                            disabled={!isEdit}
                          />
                        </Col>
                        <Col md={6}>
                          <label style={styles.label}>Query Description</label>
                          <Field
                            style={{
                              ...(isEdit
                                ? styles.textarea
                                : styles.textareaDisabled),
                              height: "6rem",
                            }}
                            name="description"
                            as="textarea"
                            disabled={!isEdit}
                          />
                        </Col>
                      </Row>

                      {/* ── Section 3: Recommendation Details ── */}
                      <SH icon={faFlask} title="Recommendation Details" />
                      <SolutionsEditor
                        solutions={
                          isEdit && !(values.solutions || []).length
                            ? [emptySolution()]
                            : values.solutions || []
                        }
                        onChange={(s) => setFieldValue("solutions", s)}
                        allProducts={allProducts}
                        readOnly={!isEdit}
                      />

                      {/* ── Section 4: Farmer Query Online (edit/view only) ── */}
                      <SH icon={faCommentDots} title="Farmer Query (Online)" />
                      <Row>
                        <Col md={3}>
                          <TextField
                            label="Query ID"
                            name="issueCode"
                            type="text"
                            disabled={true}
                          />
                        </Col>
                        <Col md={3}>
                          <label style={styles.label}>Date Raised</label>
                          <input
                            type="text"
                            value={
                              values.created_at
                                ? moment(values.created_at).format("DD/MM/YYYY")
                                : ""
                            }
                            disabled
                            style={styles.selectDisabled}
                            readOnly
                          />
                        </Col>
                        <Col md={3}>
                          <label style={styles.label}>Query Raised By</label>
                          <Field
                            style={
                              isEdit ? styles.select : styles.selectDisabled
                            }
                            as="select"
                            name="assignee"
                            disabled={!isEdit}
                          >
                            {allUsers.map((val) => (
                              <option key={val._id} value={val._id}>
                                {val.fullName}
                              </option>
                            ))}
                          </Field>
                        </Col>
                        <Col md={3}>
                          <label style={styles.label}>Last Updated On</label>
                          <input
                            type="text"
                            value={
                              values.updated_at
                                ? moment(values.updated_at).format("DD/MM/YYYY")
                                : ""
                            }
                            disabled
                            style={styles.selectDisabled}
                            readOnly
                          />
                        </Col>
                      </Row>
                      <Row className="mt-2">
                        <Col md={4}>
                          <label style={styles.label}>Query Status</label>
                          <Field
                            style={
                              isEdit ? styles.select : styles.selectDisabled
                            }
                            as="select"
                            name="status"
                            disabled={!isEdit}
                          >
                            <option value="New">New</option>
                            <option value="In Progress">In Progress</option>
                            <option value="SolutionProvided">
                              SolutionProvided
                            </option>
                            <option value="In Follow Up">In Follow Up</option>
                            <option value="Done">Done</option>
                            <option value="On Hold">On Hold</option>
                            <option value="Rejected">Rejected</option>
                          </Field>
                        </Col>
                      </Row>

                      {/* ── Section 5: Field Observation ── */}
                      <SH icon={faEye} title="Field Observation" />
                      <Row>
                        <Col>
                          <label style={styles.label}>
                            Crop Query (On Field)
                          </label>
                          <Field
                            style={{
                              ...(isEdit
                                ? styles.textarea
                                : styles.textareaDisabled),
                              height: "6rem",
                            }}
                            name="fieldObservation"
                            as="textarea"
                            disabled={!isEdit}
                          />
                        </Col>
                      </Row>
                      <Row className="mt-2">
                        <Col>
                          <label style={styles.label}>Issue Verification</label>
                          <div
                            style={{
                              display: "flex",
                              gap: "1.5rem",
                              marginTop: 4,
                            }}
                          >
                            {["matched", "unmatched"].map((v) => (
                              <label
                                key={v}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 6,
                                  cursor: isEdit ? "pointer" : "default",
                                  fontSize: "0.86rem",
                                }}
                              >
                                <Field
                                  type="radio"
                                  name="issueVerification"
                                  value={v}
                                  disabled={!isEdit}
                                />
                                {v.charAt(0).toUpperCase() + v.slice(1)}
                              </label>
                            ))}
                          </div>
                        </Col>
                      </Row>

                      {/* ── Section 6: Follow-Up & Status ── */}
                      <SH icon={faCalendarCheck} title="Follow-Up & Status" />
                      <Row>
                        <Col md={4}>
                          <label style={styles.label}>
                            Next Follow-Up Date
                          </label>
                          <Field
                            style={
                              isEdit ? styles.select : styles.selectDisabled
                            }
                            type="date"
                            name="nextFollowUpDate"
                            disabled={!isEdit}
                          />
                        </Col>
                        <Col md={8}>
                          <label style={styles.label}>
                            Referred to Marketing Staff
                          </label>
                          <Field
                            style={
                              isEdit ? styles.select : styles.selectDisabled
                            }
                            type="text"
                            name="marketstaff"
                            disabled={!isEdit}
                          />
                        </Col>
                      </Row>
                      <Row className="mt-2">
                        <Col>
                          <label style={styles.label}>Solution Provided</label>
                          <Field
                            style={{
                              ...(isEdit
                                ? styles.textarea
                                : styles.textareaDisabled),
                              height: "7rem",
                            }}
                            name="solutionprovided"
                            as="textarea"
                            disabled={!isEdit}
                          />
                        </Col>
                      </Row>

                      {/* ── Section 7: Photo Documentation ── */}
                      <SH icon={faCamera} title="Photo Documentation" />
                      {/* Existing issue images */}
                      {values.images && values.images.length > 0 && (
                        <Row className="mb-3">
                          <Col>
                            <label style={styles.label}>Issue Images</label>
                            <div
                              style={{
                                display: "flex",
                                flexWrap: "wrap",
                                gap: 8,
                              }}
                            >
                              {values.images.map((img, i) => {
                                const src = img.imageURL || img.url || img;
                                return (
                                  <img
                                    key={i}
                                    src={src}
                                    alt={`Issue image ${i + 1}`}
                                    onClick={() => setLightboxUrl(src)}
                                    style={{
                                      width: 90,
                                      height: 90,
                                      objectFit: "cover",
                                      borderRadius: 8,
                                      border: "1.5px solid #d8e8dc",
                                      cursor: "zoom-in",
                                    }}
                                  />
                                );
                              })}
                            </div>
                          </Col>
                        </Row>
                      )}
                      <Row>
                        {["beforePhoto", "afterPhoto"].map((field, idx) => {
                          const label =
                            idx === 0 ? "Before Photo" : "After Photo";
                          const url = values[field];
                          return (
                            <Col md={6} key={field}>
                              <label style={styles.label}>{label}</label>
                              <div
                                style={{
                                  border: "1.5px dashed #d8e8dc",
                                  borderRadius: 10,
                                  minHeight: 310,
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  cursor: isEdit
                                    ? "pointer"
                                    : url
                                      ? "zoom-in"
                                      : "default",
                                  backgroundColor: "#fafcfb",
                                  overflow: "hidden",
                                  position: "relative",
                                }}
                                onClick={() => {
                                  if (isEdit) {
                                    document
                                      .getElementById(`photo-${field}`)
                                      .click();
                                  } else if (url) {
                                    setLightboxUrl(url);
                                  }
                                }}
                              >
                                {url ? (
                                  <img
                                    src={url}
                                    alt={label}
                                    style={{
                                      width: "100%",
                                      maxHeight: 230,
                                      objectFit: "cover",
                                      borderRadius: 9,
                                    }}
                                  />
                                ) : (
                                  <>
                                    <span
                                      style={{
                                        fontSize: "1.5rem",
                                        color: "#c0cfc5",
                                      }}
                                    >
                                      🖼
                                    </span>
                                    <span
                                      style={{
                                        fontSize: "0.75rem",
                                        color: "#6c757d",
                                      }}
                                    >
                                      {isEdit
                                        ? "Click to upload / Attach photo"
                                        : "No photo"}
                                    </span>
                                    {isEdit && (
                                      <span
                                        style={{
                                          fontSize: "0.65rem",
                                          color: "#adb5bd",
                                        }}
                                      >
                                        JPG, PNG (Max. 5 MB)
                                      </span>
                                    )}
                                  </>
                                )}
                              </div>
                              {isEdit && (
                                <input
                                  id={`photo-${field}`}
                                  type="file"
                                  accept="image/*"
                                  style={{ display: "none" }}
                                  onChange={(e) => {
                                    const file = e.target.files[0];
                                    e.target.value = "";
                                    if (!file) return;
                                    if (file.size > 5 * 1024 * 1024) {
                                      setShowImgSizeErr(true);
                                      return;
                                    }
                                    setCropTarget({ field, file });
                                  }}
                                />
                              )}
                            </Col>
                          );
                        })}
                      </Row>
                    </Form>
                  </Card.Body>
                </Card>
                {cropTarget.file && (
                  <ImageCropModal
                    imageFile={cropTarget.file}
                    aspectRatio={4 / 3}
                    onComplete={async (blob) => {
                      const res = await uploadIssuePhoto(blob);
                      if (res?.data?.imageUrl)
                        setFieldValue(cropTarget.field, res.data.imageUrl);
                      setCropTarget({ field: null, file: null });
                    }}
                    onCancel={() => setCropTarget({ field: null, file: null })}
                  />
                )}
              </>
            );
          }}
        </Formik>
      )}
      {showEditIssueAlert && (
        <ModalAlert
          size="lg"
          variant="danger"
          message="Some Error Occurred."
          resetCallback={setShowEditIssueAlert}
        />
      )}
      {showImgSizeErr && (
        <ModalAlert
          size="lg"
          variant="danger"
          message="Image exceeds 5 MB limit. Please choose a smaller file."
          resetCallback={setShowImgSizeErr}
        />
      )}

      {/* ── Lightbox ── */}
      {lightboxUrl && (
        <div
          onClick={() => setLightboxUrl(null)}
          style={{
            position: "fixed",
            inset: 0,
            zIndex: 2000,
            backgroundColor: "rgba(0,0,0,0.88)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "zoom-out",
          }}
        >
          <img
            src={lightboxUrl}
            alt="Preview"
            onClick={(e) => e.stopPropagation()}
            style={{
              maxWidth: "90vw",
              maxHeight: "90vh",
              borderRadius: 10,
              boxShadow: "0 8px 48px rgba(0,0,0,0.6)",
              objectFit: "contain",
              cursor: "default",
            }}
          />
          <button
            onClick={() => setLightboxUrl(null)}
            style={{
              position: "fixed",
              top: 18,
              right: 22,
              background: "rgba(255,255,255,0.15)",
              border: "1px solid rgba(255,255,255,0.3)",
              borderRadius: "50%",
              width: 38,
              height: 38,
              color: "#fff",
              fontSize: "1.1rem",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              lineHeight: 1,
            }}
            aria-label="Close"
          >
            ✕
          </button>
        </div>
      )}
    </>
  );
};

export default IssueDetails;
